import {
  PatientTaskSearch,
  TaskCreate,
  TaskUpdateOverdue,
  PractitionerTaskSearch,
  TaskUpdateStatus,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class TaskApi {
  public getPatientSWRKey(id: string) {
    return `patient-tasks/${id}`;
  }

  public readonly userTasksBaseSWRKey = 'user-tasks';

  public async patientCreate(body: TaskCreate) {
    await trpc.client.task.create.mutate(body);
  }

  public async updateStatus(body: TaskUpdateStatus) {
    await trpc.client.task.update.mutate(body);
  }

  public async updateOverdue({ id, dueDate, note }: TaskUpdateOverdue) {
    await trpc.client.task.update.mutate({ id, dueDate: dueDate.toString(), note });
  }

  public async patientGet(body: PatientTaskSearch) {
    await trpc.client.patient.getTasks.query(body);
  }

  public async practitionerGet(body: PractitionerTaskSearch) {
    await trpc.client.practitioner.getTasks.query(body);
  }
}
